import { ModuleList } from './ModuleList';
import { SpeakerList } from './SpeakerList';
import { SponsorList } from './SponsorList';
import { DiscoveryContentTypes } from '../../../../../constants';
import { UseInfiniteScrollProps } from '../../../../../hooks';

export interface ContentTypeBuilderProps {
  contentType: DiscoveryContentTypes;
  loadMoreFilterResults: UseInfiniteScrollProps['fetchMoreData'];
  enableLoadingByScroll: boolean;
}

export function ContentTypeBuilder(props: ContentTypeBuilderProps) {
  const { contentType, loadMoreFilterResults, enableLoadingByScroll } = props;

  switch (contentType) {
    case DiscoveryContentTypes.MODULE:
      return (
        <ModuleList
          loadMoreResults={loadMoreFilterResults}
          enableLoadingByScroll={enableLoadingByScroll}
        />
      );
    case DiscoveryContentTypes.SPEAKER:
      return (
        <SpeakerList
          loadMoreResults={loadMoreFilterResults}
          enableLoadingByScroll={enableLoadingByScroll}
        />
      );
    case DiscoveryContentTypes.SPONSOR:
      return (
        <SponsorList
          loadMoreResults={loadMoreFilterResults}
          enableLoadingByScroll={enableLoadingByScroll}
        />
      );
    default:
      return null;
  }
}
